/*
**  rui-icon.js
**
**  rui-icon component
**
**  This component relies on the rui-main.css file being loaded into the application.
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
import { styleMap } from 'lit-html/directives/style-map';
export class RuiIcon extends LitElement {
    static get is() {
        return 'rui-icon';
    }
    static get properties() {
        return {
            iconType: { type: String },
            context: { type: String },
            size: { type: String }
        };
    }
    constructor() {
        super();
        this.iconType = '';
        this.context = '';
        this.size = '';
    }
    render() {
        const classes = {
            ['rui-icon-' + this.iconType]: true,
            [this.context ? 'rui-icon-context-' + this.context.toLowerCase() : 'rui-icon-context-default']: true
        };
        let styles = {};
        if (this.size) {
            styles.width = this.size;
            styles.height = this.size;
            styles.fontSize = this.size;
        }
        ;
        return html `<i class="rui-icon ${classMap(classes)}" style="${styleMap(styles)}" aria-hidden="true"></i>`;
    }
    static get styles() {
        return css `
            .rui-icon {
                font-family: "JHAIcons";
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                display: inline-block;
            }
            .rui-icon-context-default {
                color: var(--text-regular, #181830);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-default-disabled {
                color: var(--text-disabled, #999);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-primary-btn {
                color: var(--btn-primary-fg, #fff);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-secondary-btn {
                color: var(--btn-secondary-fg, #3878ab);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-disabled-btn {
                color: var(--btn-primary-fg-disabled, #999);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-grid-btn {
                color: var(--accent, #287cc0);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-grid-btn-disabled {
                color: var(--grid-btn-fg-disabled, #ccc);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-destructive-btn {
                color: var(--btn-destructive-fg, #e13329);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-submenu-btn {
                color: var(--btn-primary-fg, #fff);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-header {
                color: var(--main-header-fg, #eee);
                width: 16px;
                height: 16px;
                font-size: 16px;
            }
            .rui-icon-context-header-hover {
                color: var(--btn-primary-fg, #fff);
                width: 16px;
                height: 16px;
                font-size: 16px;
            }
            .rui-icon-context-nav {
                color: var(--main-nav-fg-inactive, #ddd);
                width: 18px;
                height: 18px;
                font-size: 18px;
            }
            .rui-icon-context-nav-hover {
                color: var(--btn-primary-fg, #fff);
                width: 18px;
                height: 18px;
                font-size: 18px;
            }
            .rui-icon-context-nav-arrow {
                color: var(--main-nav-fg-inactive, #ddd);
                width: 14px;
                height: 14px;
                font-size: 14px;
                transform: rotate(-90deg);
            }
            .rui-icon-context-nav-arrow-hover {
                color: var(--btn-primary-fg, #fff);
                width: 14px;
                height: 14px;
                font-size: 14px;
                transform: rotate(-90deg);
            }
            .rui-icon-context-toggle-btn {
                color: var(--btn-misc-fg, #3878ab);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-group-box-arrow {
                color: var(--text-bright, #3c5c72);
                width: 13px;
                height: 13px;
                font-size: 13px;
            }
            .rui-icon-context-group-box-arrow-error {
                color: var(--btn-destructive-fg, #e13329);
                width: 13px;
                height: 13px;
                font-size: 13px;
            }
            .rui-icon-context-sort-btn {
                color: var(--accent, #287cc0);
                width: 12px;
                height: 12px;
                font-size: 12px;
            }
            .rui-icon-context-tile-default-large-wide {
                color: var(--btn-primary-fg, #fff);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .6;
            }
            .rui-icon-context-tile-highlighted-large-wide {
                color: var(--tile-highlighted-fg, #333);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .3;
            }
            .rui-icon-context-tile-alternate1-large-wide {
                color: var(--tile-alternate1-fg, #fff);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .6;
            }
            .rui-icon-context-tile-alternate2-large-wide {
                color: var(--tile-alternate2-fg, #fff);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .6;
            }
            .rui-icon-context-tile-alternate3-large-wide {
                color: var(--tile-alternate3-fg, #fff);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .6;
            }
            .rui-icon-context-tile-disabled-large-wide {
                color: var(--btn-primary-fg-disabled, #999);
                width: 48px;
                height: 48px;
                font-size: 48px;
            }
            .rui-icon-context-tile-error-large-wide {
                color: var(--btn-destructive-fg, #e13329);
                width: 48px;
                height: 48px;
                font-size: 48px;
                opacity: .6;
            }
            .rui-icon-context-tile-default-small {
                color: var(--btn-primary-fg, #fff);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .6;
            }
            .rui-icon-context-tile-highlighted-small {
                color: var(--tile-highlighted-fg, #333);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .3;
            }
            .rui-icon-context-tile-alternate1-small {
                color: var(--tile-alternate1-fg, #fff);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .6;
            }
            .rui-icon-context-tile-alternate2-small {
                color: var(--tile-alternate2-fg, #fff);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .6;
            }
            .rui-icon-context-tile-alternate3-small {
                color: var(--tile-alternate3-fg, #fff);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .6;
            }
            .rui-icon-context-tile-disabled-small {
                color: var(--btn-primary-fg-disabled, #999);
                width: 28px;
                height: 28px;
                font-size: 28px;
            }
            .rui-icon-context-tile-error-small {
                color: var(--btn-destructive-fg, #e13329);
                width: 28px;
                height: 28px;
                font-size: 28px;
                opacity: .6;
            }
            .rui-icon-context-status-icon-information {
                color: var(--notification-info-accent, #56ace1);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-status-icon-error {
                color: var(--notification-error-accent, #f7624a);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-status-icon-warning {
                color: var(--notification-warning-accent, #efb71f);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-status-icon-success {
                color: var(--notification-success-accent, #6abf6c);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-status-icon-trendup {
                color: var(--notification-success-accent, #6abf6c);
                transform: rotate(-90deg);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-status-icon-trenddown {
                color: var(--notification-error-accent, #f7624a);
                transform: rotate(-90deg);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-header-hamburger {
                color: var(--main-header-fg, #eee);
                width: 23px;
                height: 23px;
                font-size: 23px;
            }
            .rui-icon-context-header-back {
                color: var(--main-header-fg, #eee);
                width: 19px;
                height: 19px;
                font-size: 19px;
            }
            .rui-icon-context-header-search {
                color: var(--search-box-fg, rgba(238, 238, 238, .75));
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-tag-close-btn {
                color: var(--text-regular, #181830);
                width: 9px;
                height: 9px;
                font-size: 9px;
                opacity: 0.66;
            }
            .rui-icon-context-rating {
                color: var(--text-regular, #181830);
                width: 14px;
                height: 14px;
                font-size: 14px;
            }
            .rui-icon-context-back-to-top-btn {
                color: var(--content-primary-bg, #fff);
                width: 23px;
                height: 23px;
                font-size: 23px;
            }
            .rui-icon-context-validation-error-navigator-arrow {
                color: var(--text-error, #e13329);
                width: 11px;
                height: 11px;
                font-size: 11px;
            }
            .rui-icon-context-expand-collapse-expanded-right {
                transform-origin: center;
                transform: rotate(-90deg);
            }
            .rui-icon-context-expand-collapse-collapsed-right {
                transform-origin: center;
                transform: rotate(0deg);
            }
            .rui-icon-context-expand-collapse-expanded-left {
                transform-origin: center;
                transform: rotate(90deg);
            }
            .rui-icon-context-expand-collapse-collapsed-left {
                transform-origin: center;
                transform: rotate(180deg);
            }
            .rui-icon-context-expand-collapse-expanded-up {
                transform-origin: center;
                transform: rotate(180deg);
            }
            .rui-icon-context-expand-collapse-collapsed-up {
                transform-origin: center;
                transform: rotate(0deg);
            }
            
            @media print {
                .rui-icon {
                    color: #000000;
                }
            }
            
            .rui-icon-4-sight:before { content: "\\e909"; }
            .rui-icon-accessibility:before { content: "\\267f"; }
            .rui-icon-account:before { content: "\\1f4b2"; }
            .rui-icon-add-new:before { content: "\\e602"; }
            .rui-icon-adobe-pdf:before { content: "\\e603"; }
            .rui-icon-adobe-xd:before { content: "\\23e7"; }
            .rui-icon-agriculture:before { content: "\\1f331"; }
            .rui-icon-alert-center:before { content: "\\1f4e3"; }
            .rui-icon-align-center:before { content: "\\e604"; }
            .rui-icon-align-justify:before { content: "\\e605"; }
            .rui-icon-align-left:before { content: "\\e606"; }
            .rui-icon-align-right:before { content: "\\e607"; }
            .rui-icon-angular:before { content: "\\234d"; }
            .rui-icon-archive:before { content: "\\1f5c4"; }
            .rui-icon-arrow-down:before { content: "\\1f53b"; }
            .rui-icon-arrow-left:before { content: "\\25c4"; }
            .rui-icon-arrow-right:before { content: "\\25ba"; }
            .rui-icon-arrow-up:before { content: "\\25b2"; }
            .rui-icon-attach:before { content: "\\1f4ce"; }
            .rui-icon-atm:before { content: "\\1f3e7"; }
            .rui-icon-audit:before { content: "\\1f575"; }
            .rui-icon-auto:before { content: "\\1f698"; }
            .rui-icon-balance:before { content: "\\2696"; }
            .rui-icon-bank:before { content: "\\1f3e6"; }
            .rui-icon-bell:before { content: "\\1f514"; }
            .rui-icon-bluetooth:before { content: "\\e927"; }
            .rui-icon-book:before { content: "\\1f4d6"; }
            .rui-icon-books:before { content: "\\1f4da"; }
            .rui-icon-branch-anywhere:before { content: "\\e6da"; }
            .rui-icon-briefcase:before { content: "\\1f4bc"; }
            .rui-icon-broadcast:before { content: "\\1f4e1"; }
            .rui-icon-bug:before { content: "\\e928"; }
            .rui-icon-building:before { content: "\\1f3e2"; }
            .rui-icon-bullets:before { content: "\\e617"; }
            .rui-icon-calculator:before { content: "\\1f5a9"; }
            .rui-icon-calendar:before { content: "\\1f4c6"; }
            .rui-icon-call-center:before { content: "\\1f5ea"; }
            .rui-icon-camera:before { content: "\\1f4f7"; }
            .rui-icon-card:before { content: "\\e61d"; }
            .rui-icon-cash:before { content: "\\1f4b5"; }
            .rui-icon-certificate:before { content: "\\e61f"; }
            .rui-icon-chart-area:before { content: "\\1f4b9"; }
            .rui-icon-chart-bar:before { content: "\\1f4ca"; }
            .rui-icon-chart-line:before { content: "\\1f5e0"; }
            .rui-icon-chart-pie:before { content: "\\25d4"; }
            .rui-icon-chat:before { content: "\\1f5eb"; }
            .rui-icon-check:before { content: "\\e627"; }
            .rui-icon-check-all:before { content: "\\e628"; }
            .rui-icon-checkbox-tick:before { content: "\\2714"; }
            .rui-icon-checklist:before { content: "\\1f5ce"; }
            .rui-icon-checkmark:before { content: "\\1f5f8"; }
            .rui-icon-circle:before { content: "\\e91a"; }
            .rui-icon-clean:before { content: "\\1f5d1"; }
            .rui-icon-clear:before { content: "\\1f5d9"; }
            .rui-icon-clock:before { content: "\\1f554"; }
            .rui-icon-close:before { content: "\\274c"; }
            .rui-icon-code:before { content: "\\2318"; }
            .rui-icon-collapse:before { content: "\\e904"; }
            .rui-icon-collateral:before { content: "\\e923"; }
            .rui-icon-collection:before { content: "\\e62e"; }
            .rui-icon-columns:before { content: "\\25a5"; }
            .rui-icon-compress:before { content: "\\e901"; }
            .rui-icon-contacts:before { content: "\\1f4c7"; }
            .rui-icon-copy:before { content: "\\1f5d0"; }
            .rui-icon-core-director:before { content: "\\e6d8"; }
            .rui-icon-core-director-teller:before { content: "\\e918"; }
            .rui-icon-cross-reference:before { content: "\\e905"; }
            .rui-icon-customer:before { content: "\\1f464"; }
            .rui-icon-cut:before { content: "\\2702"; }
            .rui-icon-data:before { content: "\\1f4bd"; }
            .rui-icon-delete:before { content: "\\2716"; }
            .rui-icon-delete-all:before { content: "\\e638"; }
            .rui-icon-disc:before { content: "\\e63a"; }
            .rui-icon-distribute:before { content: "\\273b"; }
            .rui-icon-document:before { content: "\\1f4c4"; }
            .rui-icon-document-checked:before { content: "\\e920"; }
            .rui-icon-document-in:before { content: "\\e91c"; }
            .rui-icon-document-lock:before { content: "\\1f50f"; }
            .rui-icon-document-out:before { content: "\\e91d"; }
            .rui-icon-document-unchecked:before { content: "\\e91e"; }
            .rui-icon-document-unlock:before { content: "\\1f5dd"; }
            .rui-icon-documents:before { content: "\\1f5ca"; }
            .rui-icon-dollar:before { content: "\\24"; }
            .rui-icon-download:before { content: "\\1f4e5"; }
            .rui-icon-drag-grip:before { content: "\\2237"; }
            .rui-icon-draw-line:before { content: "\\1f589"; }
            .rui-icon-edit:before { content: "\\e63e"; }
            .rui-icon-education:before { content: "\\1f393"; }
            .rui-icon-ellipsis:before { content: "\\2026"; }
            .rui-icon-ens:before { content: "\\e916"; }
            .rui-icon-enterprise-workflow:before { content: "\\e903"; }
            .rui-icon-error:before { content: "\\274e"; }
            .rui-icon-expand:before { content: "\\e640"; }
            .rui-icon-export:before { content: "\\e641"; }
            .rui-icon-favorites:before { content: "\\2730"; }
            .rui-icon-figma:before { content: "\\e917"; }
            .rui-icon-filter:before { content: "\\26ca"; }
            .rui-icon-fingerprint:before { content: "\\e911"; }
            .rui-icon-fit-height:before { content: "\\2b0d"; }
            .rui-icon-fit-width:before { content: "\\2b0c"; }
            .rui-icon-flag:before { content: "\\2691"; }
            .rui-icon-folder:before { content: "\\1f4c1"; }
            .rui-icon-folder-save:before { content: "\\e929"; }
            .rui-icon-font:before { content: "\\1f5da"; }
            .rui-icon-formula:before { content: "\\2211"; }
            .rui-icon-forward:before { content: "\\1f585"; }
            .rui-icon-full-screen-collapse:before { content: "\\e64a"; }
            .rui-icon-full-screen-expand:before { content: "\\e64b"; }
            .rui-icon-gauge:before { content: "\\e64c"; }
            .rui-icon-gears:before { content: "\\2699"; }
            .rui-icon-go-to:before { content: "\\e907"; }
            .rui-icon-gold:before { content: "\\e64f"; }
            .rui-icon-grayscale:before { content: "\\25cd"; }
            .rui-icon-hamburger:before { content: "\\2630"; }
            .rui-icon-health:before { content: "\\2764"; }
            .rui-icon-help:before { content: "\\2753"; }
            .rui-icon-hide:before { content: "\\e90f"; }
            .rui-icon-highlight:before { content: "\\1f58a"; }
            .rui-icon-history:before { content: "\\1f5db"; }
            .rui-icon-home:before { content: "\\1f3e0"; }
            .rui-icon-hourglass:before { content: "\\23f3"; }
            .rui-icon-i-talk:before { content: "\\1f4ac"; }
            .rui-icon-identification:before { content: "\\e915"; }
            .rui-icon-image:before { content: "\\e655"; }
            .rui-icon-image-center:before { content: "\\1f4f0"; }
            .rui-icon-images:before { content: "\\e656"; }
            .rui-icon-import:before { content: "\\e657"; }
            .rui-icon-information:before { content: "\\2139"; }
            .rui-icon-install:before { content: "\\e65a"; }
            .rui-icon-insurance:before { content: "\\2602"; }
            .rui-icon-international:before { content: "\\1f310"; }
            .rui-icon-internet-banking:before { content: "\\e926"; }
            .rui-icon-inventory:before { content: "\\1f4c3"; }
            .rui-icon-invert:before { content: "\\25e9"; }
            .rui-icon-invoice:before { content: "\\1f5c8"; }
            .rui-icon-credit-line:before { content: "\\1f5c8"; }
            .rui-icon-join:before { content: "\\e912"; }
            .rui-icon-key:before { content: "\\1f511"; }
            .rui-icon-keyboard:before { content: "\\2328"; }
            .rui-icon-layout:before { content: "\\25f3"; }
            .rui-icon-ledgers:before { content: "\\1f516"; }
            .rui-icon-link:before { content: "\\260d"; }
            .rui-icon-link-broken:before { content: "\\e925"; }
            .rui-icon-loan:before { content: "\\1f4af"; }
            .rui-icon-lock-closed:before { content: "\\1f512"; }
            .rui-icon-lock-open:before { content: "\\1f513"; }
            .rui-icon-login-logout:before { content: "\\1f512"; }
            .rui-icon-mail:before { content: "\\2709"; }
            .rui-icon-map:before { content: "\\e906"; }
            .rui-icon-map-location:before { content: "\\e66b"; }
            .rui-icon-media-back:before { content: "\\23ee"; }
            .rui-icon-media-eject:before { content: "\\23cf"; }
            .rui-icon-media-fast-forward:before { content: "\\23e9"; }
            .rui-icon-media-next:before { content: "\\23ed"; }
            .rui-icon-media-pause:before { content: "\\23f8"; }
            .rui-icon-media-play:before { content: "\\23f5"; }
            .rui-icon-media-reverse:before { content: "\\23ea"; }
            .rui-icon-media-stop:before { content: "\\23f9"; }
            .rui-icon-message:before { content: "\\1f5e8"; }
            .rui-icon-microphone:before { content: "\\1f3a4"; }
            .rui-icon-microsoft-access:before { content: "\\e675"; }
            .rui-icon-microsoft-dot-net:before { content: "\\223c"; }
            .rui-icon-microsoft-excel:before { content: "\\e676"; }
            .rui-icon-microsoft-one-note:before { content: "\\e677"; }
            .rui-icon-microsoft-outlook:before { content: "\\e678"; }
            .rui-icon-microsoft-power-point:before { content: "\\e679"; }
            .rui-icon-microsoft-word:before { content: "\\e67a"; }
            .rui-icon-moon:before { content: "\\1f319"; }
            .rui-icon-more-info:before { content: "\\e91b"; }
            .rui-icon-network:before { content: "\\1f5a7"; }
            .rui-icon-next:before { content: "\\279e"; }
            .rui-icon-non-jha-misc:before { content: "\\e657"; }
            .rui-icon-notes:before { content: "\\1f5d3"; }
            .rui-icon-odi:before { content: "\\26ef"; }
            .rui-icon-open:before { content: "\\1f4c2"; }
            .rui-icon-org-chart:before { content: "\\e682"; }
            .rui-icon-orientation-landscape:before { content: "\\e6ce"; }
            .rui-icon-orientation-portrait:before { content: "\\e6cf"; }
            .rui-icon-overdraft-protection:before { content: "\\e694"; }
            .rui-icon-package:before { content: "\\1f4e6"; }
            .rui-icon-package-add:before { content: "\\e924"; }
            .rui-icon-package-pre-deploy:before { content: "\\e922"; }
            .rui-icon-package-remove:before { content: "\\e921"; }
            .rui-icon-palette:before { content: "\\e684"; }
            .rui-icon-paste:before { content: "\\1f4cb"; }
            .rui-icon-pay:before { content: "\\1f4b3"; }
            .rui-icon-people:before { content: "\\1f465"; }
            .rui-icon-people-group:before { content: "\\1f46a"; }
            .rui-icon-person:before { content: "\\1f464"; }
            .rui-icon-person-info:before { content: "\\e68a"; }
            .rui-icon-phone:before { content: "\\1f4de"; }
            .rui-icon-phone-mobile:before { content: "\\1f4f1"; }
            .rui-icon-pin:before { content: "\\1f588"; }
            .rui-icon-plane:before { content: "\\1f6ea"; }
            .rui-icon-plug:before { content: "\\1f50c"; }
            .rui-icon-pointer:before { content: "\\27a1"; }
            .rui-icon-power:before { content: "\\e91f"; }
            .rui-icon-preview:before { content: "\\e68f"; }
            .rui-icon-previous:before { content: "\\27f5"; }
            .rui-icon-print:before { content: "\\1f5b6"; }
            .rui-icon-priority-1:before { content: "\\2776"; }
            .rui-icon-priority-2:before { content: "\\278b"; }
            .rui-icon-priority-3:before { content: "\\278c"; }
            .rui-icon-process:before { content: "\\1f300"; }
            .rui-icon-profit-stars:before { content: "\\e6d6"; }
            .rui-icon-properties:before { content: "\\e692"; }
            .rui-icon-prospect:before { content: "\\e693"; }
            .rui-icon-protected:before { content: "\\e694"; }
            .rui-icon-question:before { content: "\\e914"; }
            .rui-icon-quick:before { content: "\\e696"; }
            .rui-icon-rates:before { content: "\\e697"; }
            .rui-icon-rating-empty:before { content: "\\2606"; }
            .rui-icon-rating-full:before { content: "\\2605"; }
            .rui-icon-rating-half:before { content: "\\e919"; }
            .rui-icon-redo:before { content: "\\293f"; }
            .rui-icon-refresh:before { content: "\\e699"; }
            .rui-icon-reload:before { content: "\\1f503"; }
            .rui-icon-reminder:before { content: "\\23f0"; }
            .rui-icon-reply:before { content: "\\1f4e8"; }
            .rui-icon-reply-all:before { content: "\\1f4e9"; }
            .rui-icon-report:before { content: "\\1f4d3"; }
            .rui-icon-rotate-right:before { content: "\\27f3"; }
            .rui-icon-rotate-left:before { content: "\\27f2"; }
            .rui-icon-rows:before { content: "\\e913"; }
            .rui-icon-rss:before { content: "\\e69a"; }
            .rui-icon-safe-deposit-box:before { content: "\\e6a1"; }
            .rui-icon-savings:before { content: "\\1f4b0"; }
            .rui-icon-scanner:before { content: "\\e6a5"; }
            .rui-icon-search:before { content: "\\1f50d"; }
            .rui-icon-select:before { content: "\\1f446"; }
            .rui-icon-send:before { content: "\\1f586"; }
            .rui-icon-server:before { content: "\\1f5a5"; }
            .rui-icon-settings:before { content: "\\1f527"; }
            .rui-icon-share:before { content: "\\1f504"; }
            .rui-icon-shareholder:before { content: "\\1f5e1"; }
            .rui-icon-shopping-cart:before { content: "\\1f3ec"; }
            .rui-icon-show:before { content: "\\e908"; }
            .rui-icon-shuffle:before { content: "\\1f501"; }
            .rui-icon-signature:before { content: "\\2712"; }
            .rui-icon-silver-lake:before { content: "\\e90a"; }
            .rui-icon-sms:before { content: "\\e6a6"; }
            .rui-icon-sort-ascending:before { content: "\\e6af"; }
            .rui-icon-sort-descending:before { content: "\\e6b0"; }
            .rui-icon-sound-off:before { content: "\\1f507"; }
            .rui-icon-sound-on:before { content: "\\1f50a"; }
            .rui-icon-split:before { content: "\\e6b1"; }
            .rui-icon-square:before { content: "\\1f5c6"; }
            .rui-icon-stamp:before { content: "\\e90b"; }
            .rui-icon-steps:before { content: "\\e902"; }
            .rui-icon-sticky-note:before { content: "\\1f5c9"; }
            .rui-icon-stock:before { content: "\\1f5e1"; }
            .rui-icon-stop:before { content: "\\270b"; }
            .rui-icon-success:before { content: "\\2611"; }
            .rui-icon-sun:before { content: "\\2600"; }
            .rui-icon-support:before { content: "\\2bd1"; }
            .rui-icon-swap:before { content: "\\1f500"; }
            .rui-icon-synapsys:before { content: "\\e6b5"; }
            .rui-icon-synergy:before { content: "\\e6d7"; }
            .rui-icon-table:before { content: "\\25a6"; }
            .rui-icon-tablet:before { content: "\\e900"; }
            .rui-icon-tag:before { content: "\\e90d"; }
            .rui-icon-target:before { content: "\\1f3af"; }
            .rui-icon-task:before { content: "\\e6b8"; }
            .rui-icon-tax-plan:before { content: "\\e92e"; }
            .rui-icon-text-bold:before { content: "\\1d5d5"; }
            .rui-icon-text-italic:before { content: "\\1d43c"; }
            .rui-icon-text-normal:before { content: "\\1d683"; }
            .rui-icon-text-underline:before { content: "\\e6bd"; }
            .rui-icon-thumbs-down:before { content: "\\1f44e"; }
            .rui-icon-thumbs-up:before { content: "\\1f44d"; }
            .rui-icon-time-deposit:before { content: "\\e92b"; }
            .rui-icon-tip:before { content: "\\1f4a1"; }
            .rui-icon-tools:before { content: "\\1f528"; }
            .rui-icon-touch:before { content: "\\e6c6"; }
            .rui-icon-transfer:before { content: "\\21c6"; }
            .rui-icon-twenty-twenty:before { content: "\\e6d3"; }
            .rui-icon-uncheck-all:before { content: "\\1f5c7"; }
            .rui-icon-uncompress:before { content: "\\e90c"; }
            .rui-icon-undo:before { content: "\\21b6"; }
            .rui-icon-upload:before { content: "\\1f4e4"; }
            .rui-icon-ux:before { content: "\\26ee"; }
            .rui-icon-vendor:before { content: "\\1f3e2"; }
            .rui-icon-verify:before { content: "\\e6cd"; }
            .rui-icon-vertex:before { content: "\\e6d5"; }
            .rui-icon-video:before { content: "\\1f4f9"; }
            .rui-icon-view-icons:before { content: "\\268f"; }
            .rui-icon-view-list:before { content: "\\e6dc"; }
            .rui-icon-voice-mail:before { content: "\\e90e"; }
            .rui-icon-warning:before { content: "\\26a0"; }
            .rui-icon-web:before { content: "\\1f311"; }
            .rui-icon-web-component:before { content: "\\e910"; }
            .rui-icon-window:before { content: "\\e6e3"; }
            .rui-icon-window-close:before { content: "\\1f5d9"; }
            .rui-icon-window-dropdown:before { content: "\\2335"; }
            .rui-icon-window-minimize:before { content: "\\25ac"; }
            .rui-icon-window-maximize:before { content: "\\1f5d6"; }
            .rui-icon-window-restore:before { content: "\\1f5d7"; }
            .rui-icon-windows:before { content: "\\e6e4"; }
            .rui-icon-wire-transfer:before { content: "\\2b93"; }
            .rui-icon-workstation:before { content: "\\1f4fa"; }
            .rui-icon-xperience:before { content: "\\e6e7"; }
            .rui-icon-yellow-hammer:before { content: "\\1f529"; }
            .rui-icon-zoom-in:before { content: "\\1f453"; }
            .rui-icon-zoom-out:before { content: "\\e6e9"; }
        `;
    }
}
customElements.get(RuiIcon.is) || customElements.define(RuiIcon.is, RuiIcon);
